/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import constants from '../../utils/constants';

const Links = () => {
  const {
    sites: { us },
  } = constants;

  return (
    <section className="app-site-links">
      <div className="link-row">
        <div className="column links-1">
          <ul>
            <li>
              <a href={`https://${us}/company/careers/`}>Careers</a>
            </li>
            <li>
              <a href="https://help.kabbage.com/">Help Center</a>
            </li>
            <li>
              <a href={`https://${us}/resource-center/`}>Resource Center</a>
            </li>
            <li>
              <a href="https://newsroom.kabbage.com/">Newsroom</a>
            </li>
            <li>
              <a href={`https://${us}/partner/`}>Partner Program</a>
            </li>
          </ul>
        </div>
        <div className="column links-2">
          <ul>
            <li>
              <a href="mailto:support@kabbage.com">support@kabbage.com</a>
            </li>
            <li>
              <a href="mailto:media@kabbage.com">media@kabbage.com</a>
            </li>
            <li>
              <a href="mailto:partnerships@kabbage.com">
                partnerships@kabbage.com
              </a>
            </li>
          </ul>
        </div>
        <div className="apps">
          <h3>Get the Kabbage app:</h3>
          <a
            href="https://control.kochava.com/v1/cpi/click?campaign_id=kokabbage-ios571109f58fdb73925a215c2da2&network_id=8494&site_id=1&device_id=device_id"
            className="button apple"
          />
          <a
            href="https://control.kochava.com/v1/cpi/click?campaign_id=kokabbage-android57110b6b724ac15196176bab2e&network_id=8494&site_id=1&device_id=device_id"
            className="button google"
          />
        </div>
      </div>
    </section>
  );
};

export default Links;
